module.exports = __webpack_public_path__ + "img/nodejs-logo.f1073ec6.svg";